import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/admin/expense-categories`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/admin/expense-categories`, body, config);
};

export const Put = (id, body, config = {}) => {
  return APIService.put(`/admin/expense-categories/${id}`, body, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/admin/expense-categories/${id}`, config);
};

const ExpenseCategoryService = {
  List,
  Create,
  Put,
  Delt,
};
export default ExpenseCategoryService;
